import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'

import { stylesBootstrap } from '../styles/bootstrap'
import { isNullishOrWhitespace } from '../functions/nullish'

/**
 * See: https://getbootstrap.com/docs/5.3/layout/containers/#how-they-work
 */
export type BootstrapContainerBreakpoint = null | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fluid'

@customElement('bootstrap-container')
export class BootstrapContainer extends LitElement {
  @property({ attribute: 'breakpoint' })
  breakpoint: BootstrapContainerBreakpoint = null;

  render() {
    return html`
      <div class="container" class=${classMap({
        'container': isNullishOrWhitespace(this.breakpoint),
        'container-sm': this.breakpoint === 'sm',
        'container-md': this.breakpoint === 'md',
        'container-lg': this.breakpoint === 'lg',
        'container-xl': this.breakpoint === 'xl',
        'container-xxl': this.breakpoint === 'xxl',
        'container-fluid': this.breakpoint === 'fluid',
      })}>
        <slot></slot>
      </div>
    `
  }


  static styles = [stylesBootstrap, css`
    :host {
      display: block;
    }
  `]
}

declare global {
  interface HTMLElementTagNameMap {
    'bootstrap-container': BootstrapContainer
  }
}
